import { createBrowserRouter, Navigate } from "react-router-dom";
import { App } from "./App";
import { SetupLogin } from "./routes/SetupLogin";
import { GroupsAndTags } from "./routes/GroupsAndTags";
import { Compose } from "./routes/Compose";
import { Cupon } from "./routes/Cupon";
import { SendMonitor } from "./routes/SendMonitor";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/groups" replace /> },
      { path: "setup", element: <SetupLogin /> },
      { path: "groups", element: <GroupsAndTags /> },
      { path: "compose", element: <Compose /> },
      { path: "cupon", element: <Cupon /> },
      { path: "send", element: <SendMonitor /> },
    ],
  },
]);
